<!--
- 医院列表组件
- anthor: wang.y
- greatTime: 2019-08-12
-->
<template>
    <li>
        <div class="logo_img" @click="goEntityDetail(dataLi.uid)">
            <img :src="dataLi.logo_path | logo_show" />
        </div>
        <div class="entity_info">
            <p class="p1 clear">
                <span
                    class="span_name"
                    v-html="filter.keyWordHighLight(dataLi.short_name, keyword)"
                    @click="goEntityDetail(dataLi.uid)"
                ></span>
            </p>
            <p class="p2" v-if="dataLi.description" v-html="filter.keyWordHighLight(dataLi.description, keyword)"></p>
            <p class="p2" v-else>暂无描述</p>
        </div>
    </li>
</template>

<script>
import filter from 'js/filter'
export default {
  inject: ['login'],
  props: ['dataLi', 'keyword'],
  data() {
    return {
      filter: filter
    }
  },
  methods: {
    /**
    * 前往实体详情
    */
    goEntityDetail(uid) {
      if (this.$store.state.user_key) {
        // this.$router.push({name: 'HospitalDetail', params: {uid: uid}})
        const { href } = this.$router.resolve({
          name: "HospitalDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else {
        this.login()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/searchEntity.stylus'
.entity > li .entity_info
  flex: auto
  .p1 .span_name
  .p2
    max-width: 316px
</style>
